export default __webpack_public_path__ + "static/media/check.28bf1dc9.svg";